import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CardItem from '../../base/Blog';
import Styles from './Cards.styles';

const cardsColors = ['green', 'pink', 'yellow', 'purple', 'aqua'];

const InnerWrapper = styled.div`
  ${Styles.innerwrapper};
`;
const Col = styled.div`${Styles.col}`;
const Card = styled(CardItem)`${Styles.cardItem}`;
/**
 * Cards components
 * @property {Array} items - card items
 * @returns {JSX}
 */
const Cards = ({ items }) => {
  return (
    <InnerWrapper style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row" style={{}}>
          {items.map((item, index) => (
            <Col className="col-12 col-sm-4" key={item.title}>
              <Card className="col" {...item} gradientColor={cardsColors[index % 5]} />
            </Col>
          ))}
        </div>
      </div>
    </InnerWrapper>
  );
};

Cards.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      gradientColor: PropTypes.oneOf(['pink', 'green', 'yellow']),
      backgroundImage: PropTypes.object,
      backgroundAlignent: PropTypes.oneOf(['top', 'center', 'bottom']),
      title: PropTypes.string,
      description: PropTypes.string,
      link: PropTypes.string,
      className: PropTypes.string
    })
  )
};

export default Cards;
